<template>
  <ui-component-modal
    modalTitle="Edit location search terms"
    :isSaving="isSaving"
    :isSavingSuccess="isSavingSuccess"
    :isSavingError="isSavingError"
    :hideFooterButtons="isSavingError || isSavingSuccess"
    :onClickCancel="onClickCancel"
    :onClickSave="saveLocationSearchTerm"
    :showModal="showModal"
    @closeModal="onClickCancel"
  >
    <template v-slot:content>
      <table class="table is-striped is-fullwidth">
        <tbody>
          <tr>
            <td>Search terms</td>
            <td>
              <input type="text" v-model="mLocation.Alt" class="input" />
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </ui-component-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import locationProvider from '@/providers/location'

export default {
  components: {},

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    onClickCancel: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      isSaving: false,
      isSavingSuccess: false,
      isSavingError: false,
      mLocation: null,
    }
  },

  computed: {
    ...mapState('locationStore', ['location']),
  },

  created() {
    this.mLocation = JSON.parse(JSON.stringify(this.location))
  },

  methods: {
    ...mapMutations('locationStore', ['setLocation']),

    saveLocationSearchTerm() {
      if (!this.isSaving) {
        this.isSaving = true;

        locationProvider.methods
        .updateLocationSearchTerm(this.mLocation.Id, this.mLocation.Alt)
        .then((response) => {
            if (response.status === 204) {
            this.setLocation(this.mLocation);

            this.isSavingSuccess = true;

            this.onClickCancel();
            }
        })
        .catch((error) => {
            this.isSavingError = true;
        })
        .finally(() => {
            this.isSaving = false;
        })

      }
    },
  },
}
</script>
